import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contenidoComboReducer(state= initialState.contenidoCombo, action){
	switch(action.type){
		case types.GET_CONTENIDOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}